export const airbnbOccupancyTaxTypes = [
  { name: $localize`Hotel tax`, id: 'pass_through_hotel_tax' },
  { name: $localize`Lodging tax`, id: 'pass_through_lodging_tax' },
  { name: $localize`Room tax`, id: 'pass_through_room_tax' },
  { name: $localize`Tourist tax`, id: 'pass_through_tourist_tax' },
  { name: $localize`Transient occupancy tax`, id: 'pass_through_transient_occupancy_tax' },
  { name: $localize`Sales tax`, id: 'pass_through_sales_tax' },
  { name: $localize`VAT/GST`, id: 'pass_through_vat_gst' },
  { name: $localize`Tourism Assessment/Fee`, id: 'pass_through_tourism_assessment_fee' },
]

export const airbnbOccupancyTaxesAttestation = [
  $localize`That the added tax amount is accurate`,
  $localize`That they are responsible for remitting the added taxes to the relevant tax authorities`,
  $localize`And that Airbnb may disclose tax-related and transaction information to the relevant tax authorities`,
]

export const airbnbOccupancyTaxCollectionType = [
  {
    id: 'INELIGIBLE',
    description: $localize`Airbnb may or may not collect certain taxes for this listing, hosts are not allowed to set custom taxes.`,
  },
  { id: 'NO_AIRBNB_COLLECTED_TAX', description: $localize`Airbnb doesn’t collect taxes, hosts can add custom taxes.` },
  {
    id: 'OVERRIDE_AIRBNB_COLLECTED_TAX',
    description: $localize`	Airbnb automatically collects certain taxes and remits them. Hosts who would like to assume the responsibility of remitting taxes, can opt-out of Airbnb’s automatic tax collection and remittance by adding your own custom taxes instead.`,
  },
  {
    id: 'STACKED_AIRBNB_COLLECTED_TAX',
    description: $localize`	Airbnb will collect and remit certain taxes directly to tax authorities and will also collect the added taxes set by the host and remit them directly to the host.`,
  },
]

export const airbnbOccupancyTaxAmountTypes = [
  { name: $localize`Percent Per Reservation`, id: 'percent_per_reservation' },
  { name: $localize`Flat Per Guest`, id: 'flat_per_guest' },
  { name: $localize`Flat Per Night`, id: 'flat_per_night' },
  { name: $localize`Flat Per Guest Per Night`, id: 'flat_per_guest_per_night' },
]

// TV4-6258: Airbnb API 2026.06.30 keeps the amounts of these taxes per season (seasonal_rates)
// and rejects `amount` in writes. They are edited on Airbnb only, so they are not in the list above.
export const airbnbSeasonalOccupancyTaxAmountTypes = [
  { name: $localize`Seasonal Flat Per Night`, id: 'seasonal_flat_per_night' },
  { name: $localize`Seasonal Flat Per Guest Per Night`, id: 'seasonal_flat_per_guest_per_night' },
  { name: $localize`Seasonal Percent Per Reservation`, id: 'seasonal_percent_per_reservation' },
]

export function isAirbnbSeasonalOccupancyTax(tax: AirbnbPassThroughOccupancyTax): boolean {
  return airbnbSeasonalOccupancyTaxAmountTypes.some((t) => t.id === tax?.amount_type)
}

export function airbnbSeasonalOccupancyTaxLabel(tax: AirbnbPassThroughOccupancyTax): string {
  const taxType = airbnbOccupancyTaxTypes.find((t) => t.id === tax.tax_type)?.name || tax.tax_type
  const amountType = airbnbSeasonalOccupancyTaxAmountTypes.find((t) => t.id === tax.amount_type)?.name
  return `${taxType} - ${amountType}`
}

export const airbnbOccupancyTaxBase = [
  // for percent_per_reservation
  { name: $localize`Base Price`, id: 'base_price' },
  { name: $localize`Resort Fee`, id: 'pass_through_resort_fee' },
  { name: $localize`Community Fee`, id: 'pass_through_community_fee' },
  { name: $localize`Management Fee`, id: 'pass_through_management_fee' },
  { name: $localize`Linen Fee`, id: 'pass_through_linen_fee' },
  { name: $localize`Cleaning Fee`, id: 'pass_through_cleaning_fee' },
  { name: $localize`Pet Fee`, id: 'pass_through_pet_fee' },
]

export interface AirbnbPassThroughOccupancyTax {
  tax_type: string // "pass_through_sales_tax",
  amount_type: string // "percent_per_reservation",
  taxable_base: string[] // ["base_price"],
  amount: number // 90,

  business_tax_id: string // "23df34",
  no_business_tax_id_declaration: boolean // false,

  tot_registration_id: string // "as23",
  no_tot_registration_id_declaration: boolean // false,

  long_term_stay_exemption: number // 23,
  only_first_nights_exemption: number // 23,
  max_cap_per_person_per_night: number // 34

  attestation: true // false,
}
